import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSSA } from "../SSAContext";

export default function CategoryHubPage() {
  const { catalogs } = useSSA();
  return (
    <div data-testid="ssa-category-hub">
      <div className="text-[11px] uppercase tracking-[0.22em] text-[#0072CE] font-bold">Strategic Services Aggregator</div>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold text-slate-900 mt-2 max-w-3xl leading-tight" data-testid="ssa-hub-headline">Services Enabled with Intelligent Sourcing and Procurement Capabilities</h1>
      <p className="text-slate-600 mt-3 max-w-2xl text-sm leading-relaxed">
        Each category has its own AI category intelligence, structured briefs, partner network and commercial model. Every request follows the same governed flow: brief, then competitive RFQ, then two options, then a back-to-back PO.
      </p>
      <div className="grid lg:grid-cols-2 gap-6 mt-8">
        {["DM", "FM"].map((c, i) => {
          const cat = catalogs[c];
          const m = cat?.meta;
          return (
            <Link key={c} to={`/services/c/${c}`} data-testid={`category-card-${c}`}
              className="group relative rounded-2xl overflow-hidden bg-[#0B2A4A] text-white min-h-[320px] flex flex-col justify-end hover:-translate-y-0.5 hover:shadow-2xl transition-[transform,box-shadow] duration-300 animate-in fade-in slide-in-from-bottom-3"
              style={{ animationDelay: `${i * 90}ms`, animationFillMode: "both" }}>
              {m?.image && <img src={m.image} alt={m.name} className="absolute inset-0 h-full w-full object-cover opacity-50 group-hover:scale-105 transition-transform duration-700" />}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B2A4A] via-[#0B2A4A]/70 to-transparent" />
              <div className="relative p-8">
                <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#7DD3FC]">{cat?.services?.length || "–"} services · {m?.pricing_model === "recurring" ? "Monthly fee + SLAs" : "Scope-based project quotes"}</div>
                <div className="font-display text-3xl font-semibold mt-2">{m?.name || (c === "FM" ? "Integrated Facilities Management" : "Digital Marketing Services")}</div>
                <p className="text-sm text-white/75 mt-2 max-w-lg">{m?.blurb}</p>
                <div className="flex flex-wrap gap-1.5 mt-4">{(cat?.families || []).map((f) => <span key={f} className="text-[10px] bg-white/10 border border-white/15 rounded-full px-2 py-0.5">{f}</span>)}</div>
                <div className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-[#00B4D8]">Open catalogue <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" /></div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
